import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import SaveIcon from "@mui/icons-material/Save";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { debounce, update } from "lodash";
import {
  createRef,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import XlxsImg from "../../../assest/Xlsx.png";
import CsvImg from "../../../assest/csv.png";
import emlFormat from "../../../assest/eml-icon.png";
import WordImg from "../../../assest/office.png";
import LanguageData from "../../../configs/LanguageData.json";
import useGetQueryParams from "../../../hooks/useGetQueryParams";
import { convertToTimeSpan } from "../../../pages/new-ticket/AddUpdate";
import AsyncDropDown from "../../../pages/new-ticket/LatestTicket/AsyncDrodown/AsyncDropDown";
import { FindItem } from "../../../pages/new-ticket/LatestTicket/Edit";
import {
  generateErrorList,
  generateIdFromObjectForTicketCreation,
  getBase64,
} from "../../../pages/new-ticket/LatestTicket/Form";
import {
  onClickThumbNail
} from "../../../pages/new-ticket/LatestTicket/RightPanel";
import {
  getValidationSchema,
  IValidationField
} from "../../../pages/new-ticket/LatestTicket/Schema";
import {
  iFormData,
  iTicketManagementProperties,
  ValidationResultS,
} from "../../../pages/new-ticket/LatestTicket/Type";
import { isValidate } from "../../../pages/new-ticket/LatestTicket/Validation";
import { getOrganisationsForDropdown } from "../../../redux/actions/CMDB/Organisation";
import {
  getAllGroup,
  getCategoryByID,
  getTicketAndUpdateLists,
  getTicketByID,
  getUsrList,
  storeNewTicketOnList
} from "../../../redux/actions/TicketsManagement/TicketsManagement";
import getTemplates from "../../../redux/actions/adminInterfaces/EmailTemplates";
import { ActionType } from "../../../redux/actions/dashboard";
import { IState } from "../../../redux/reducers/rootReducers";
import {
  addNewTicket,
  updateNewTicket,
} from "../../../services/dashboard/dashboard.service";
import {
  fileUploadServiceForBloeStorage,
  uploadTicketAttachment
} from "../../../services/fileUpload/FileUpload";
import { TextBoxLatest } from "../../common/TextBoxLatest/TextBoxLatest";
import BasicButton from "../../common/button/BasicButton";
import CustomSelect from "../../common/customSelect/CustomSelect";
import CustomFormLabel from "../../common/form-label/CustomFormLabel ";
import Radio from "../../common/radio/Radio";
import CustomInput from "../../common/textField/CustomInput";
import {
  addEllipsis,
  checkIsNoteFieldRequired,
  ConvertZ,
  parseTimeSpan
} from "../../helpers/helperFunctions";
import CloseCategoryOption from "./CloseCategoryOption";
import TicketAdditionalField from "./TicketAdditionalField";
import ArticleSuggestion, { SuggestionModalActions } from "./ArticleSuggestionModal";
import axios from "axios";
import configs from "../../../configs/config";
import { triggerAppAlert } from "../../../redux/actions/SelfServicePortal/ContactAid/ContactAid";

const ticketCreation = async (payload: any) => {
  // console.log("payload", payload);
  let newTicket: any = await addNewTicket(payload);
  return newTicket;
};

const fileAttachment = async (attachment: any) => {
  let fileAttachment = await uploadTicketAttachment(attachment);
  return fileAttachment;
};

const updateTicket = async (id: any, payload: any) => {
  // console.log("payload", payload);
  let newTicket: any = await updateNewTicket(payload, id);
  return newTicket;
};

const GenrateTemplateField = ({
  isEmailShow,
  handleSelectChange,
  value,
  setEmailChecked,
  emailChecked,
  template,
  setTemplate,
  error,
}: {
  isEmailShow: any;
  handleSelectChange: any;
  value: any;
  setEmailChecked: any;
  emailChecked: any;
  template: any;
  setTemplate: any;
  error: any;
}) => {
  const TemplatesList = useSelector(
    (state: IState) => state?.EmailTemplatesReducer?.AllEmailTemplates
  );

  useEffect(() => {
    // console.log("isEmailShow", isEmailShow);
  }, [isEmailShow]);

  const activeTemplates = useMemo(() => {
    return (template || []).filter((ele: any) => ele.isActive);
  }, [template]);
  return (
    <>
      <Grid item xs={6} md={6}>
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <Radio
              setEmailChecked={setEmailChecked}
              emailChecked={emailChecked}
            />
            <span style={{ fontSize: "14px" }}>Send Email</span>
          </div>
          {emailChecked && (
            <Box
              sx={{
                flex: '1 1 calc(50% - 16px)',
              }}
            >
              <span style={{ fontSize: "14px" }}>
                Select a Template
                <span style={{ color: "red" }}>*</span>
              </span>
              <CustomSelect
                isOpen={false}
                placeholder="Select a Template"
                width={"100%"}
                name="template"
                isColor={false}
                isDisabled={false}
                isError={( !value && generateErrorList(error.isValid, error.errors, "template")) ? true : false}
                defaultValue={value}
                options={activeTemplates}
                handleChange={(e: any) => {
                  handleSelectChange(e, "template");
                }}
                isMulti={false}
              />
              {!value && generateErrorList(error.isValid, error.errors, "template")}
            </Box>
          )}
        </>
      </Grid>
    </>
  );
};
const GenratePrivateRadioBtn = ({
  setEmailChecked,
  emailChecked,
}: {
  setEmailChecked: any;
  emailChecked: any;
}) => {
  useEffect(() => {
    // console.log("isEmailShow", emailChecked);
  }, [emailChecked]);

  return (
    <>
      <Grid item xs={6} md={6}>
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <Radio
              setEmailChecked={setEmailChecked}
              emailChecked={emailChecked}
            />
            <span style={{ fontSize: "14px" }}>Private Note</span>
          </div>
        </>
      </Grid>
    </>
  );
};

const TicketAddUpdatePopup = memo((respData: any) => {
  const classes = useTicketAddUpdatePopupStyles();
  const dispatch = useDispatch();
  const [ticketById, setTicketById] = useState<any>(null);
  const ticketInfo = useSelector(
    (state: IState) => state?.TicketViewReducer?.addUpdate
  );
  const ticketManagementProperties: iTicketManagementProperties = useSelector(
    (state: IState) => state?.TicketsReducer?.allResponses
  );

  const currAgent = useSelector(
    (state: IState) => state?.agentReducer?.loggedInAgent
  );

  const isEmailShow = useSelector(
    (state: IState) => state?.EmailSettingsReducer?.AllEmailSettings
  );

  const onCloseHandler = useCallback(() => {
    dispatch({
      type: "ADD_UPDATE_POPUP_INFO",
      payload: null,
    });
  }, []);
  useEffect(() => {
    // console.log("ticketInfo check ", ticketInfo);
    if (ticketInfo?.id && ticketInfo?.type === "quick-update") {
      dispatch(getTicketByID(ticketInfo?.id, getTicketByIDCB));
    } else {
      setTicketById(ticketInfo);
    }
  }, [ticketInfo?.id]);
  const getTicketByIDCB = (resStatus: string, res: any) => {
    // console.log("getTicketById", res);
    if (resStatus === "0") {
      // console.log("getTicketById", res);
      setTicketById({
        ...res,
        type: ticketInfo?.id,
      });
    }
  };
  const viewForm = useMemo(() => {
    return (
      <AddUpdateForm
        isEmailShow={isEmailShow}
        currAgent={currAgent}
        ticketInfo={ticketById}
        ticketManagementProperties={ticketManagementProperties}
        respData={respData}
        callback={respData?.callback}
      />
    );
  }, [ticketById]);
  const articleModalData = useSelector((state: IState) => state?.TicketViewReducer?.articleModal);
  const closeArticleModal = () => {
       dispatch({
          type: "ARTICLE_SUGGESTION_POPUP_INFO",
          payload: null
        });
  }  
  const viewContent = useMemo(() => {
    const errort = parseTimeSpan(ticketInfo?.ticketLogs?.effort);
    const articleSuggestionCB = (feedbackType: 'like' |'dislike' | undefined ,statusId: number,ticketInfo:any,articleName:any) => {
      if(feedbackType === 'like' && statusId){
        setTicketById((prevState: any) => {
          return {...prevState, ticketLogs: {...prevState.ticketLogs, statusId, forceUpdateStatus : true} };
        });
      }
      setTimeout(() => {
           closeArticleModal()
      }, 200);
    };
    
    return (
      <>
        {ticketById && (
          <>
            <Box className={`${classes.popupHolder} add-update-modal ${articleModalData?.fullScreen ? 'fullScreenModal' : ''}`}>
              <Box className="modal-dialog">
                <Box className="modal-content">
                  <Box className="modal-header">
                    {articleModalData ? 
                    <Typography variant="h6" className="txtCapitalize">
                      Quick Fix Suggestions
                    </Typography> :
                      <Typography variant="h6" className="txtCapitalize">
                        {ticketById?.id
                          ? `Update ${ticketById?.id}`
                          : "New ticket"}
                      </Typography>
                    }
                    <Box className={`gap15 ${classes.row}`}>
                    {!articleModalData ? 
                      <Typography className={classes.txtWithLink} gutterBottom>
                        <span>
                          Effort: {errort?.days}d {errort?.hours}h{" "}
                          {errort?.mins}m
                        </span>
                      </Typography>
                      :
                      <SuggestionModalActions modalInfo={articleModalData} />
                      }
                      <Typography
                        className="cursor-pointer"
                        onClick={articleModalData ? closeArticleModal : onCloseHandler}
                      >
                        <CloseIcon className="cursor-pointer" />
                      </Typography>
                    </Box>
                  </Box>
                  {articleModalData ? 
                    <ArticleSuggestion callback={articleSuggestionCB} />
                  :
                  viewForm}
                </Box>
              </Box>
            </Box>
          </>
        )}
      </>
    );
  }, [ticketById, articleModalData]);
  return <Box 
   sx={{
                  position: 'relative',   // important to avoid creating new stacking context
                  zIndex: 1300,           // dialog should have a zIndex here but lower than dropdown menu
                  overflow: 'visible',    // allow dropdown to overflow if needed
                  transform: 'none'       // prevent stacking context issues from transform
                }}>{viewContent}</Box>;
});

const AddUpdateForm = (props: any) => {
  const {
    ticketInfo,
    currAgent,
    ticketManagementProperties,
    isEmailShow,
    respData,
    callback,
  } = props;
  
  // 
  const AllInfo = useSelector(
    (state: IState) => state?.TicketsReducer?.alldataStructure
  );
  const StatusCode = useSelector(
    (state: IState) => state?.categoryReducer?.StatusCode
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const param = useParams();
  const [error, setError] = useState<ValidationResultS>({
    isValid: false,
    errors: {},
  });
  const [emailChecked, setEmailChecked] = useState<boolean>(false);
  const [template, setTemplate] = useState<any>(null);
  const [isNotePrivate, setIsPrivateNote] = useState<boolean>(true);
  const [outcomeCategoryId, setOutcomeCategoryId] = useState<any>(null);
  const statusIdFromUrl: string | boolean = useGetQueryParams("status");
  const priorityIdFromUrl: string | boolean = useGetQueryParams("priority");
  const [hasOutcomeCategory, setHasOutcomeCategory] = useState(false);
  const TemplatesList = useSelector(
    (state: IState) => state?.EmailTemplatesReducer?.AllEmailTemplates
  );

  const [loading, setLoading] = useState<boolean>(false);
  //Store default settings for add update form
  const [defaultSettings, setDefaultSettings] = useState<any>(null);
  //API call to get default settings for add update form
  const getDefaultSettings = async () => {
    try {
      const response = await axios(`${configs.BASE_URL}/SystemSettings`);
      setDefaultSettings(response?.data);
    } catch (error) {
      console.error("Error fetching default settings", error);
    }
  };
  //Temp data to test.
  // const getDefaultSettings = async () => {
  //   try {
  //     // TEMP TEST DATA
  //     setDefaultSettings([
  //       {
  //         settingsKey: "SendEmailOnUpdate",
  //         settingsValue: "true"
  //       },
  //       {
  //         settingsKey: "IsNotePrivate",
  //         settingsValue: "true"
  //       },
  //       {
  //         settingsKey: "AddUpdateEffort",
  //         settingsValue: "15"
  //       }
  //     ]);
  //   } catch (error) {
  //     console.error("Error fetching default settings", error);
  //   }
  // };
  // console.log("defaultSettingsVV", defaultSettings);
  useEffect(() => {
    if (!defaultSettings) return;
    const sendEmailSetting = defaultSettings?.find(
      (x: any) => x.settingsKey === "SendEmailOnUpdate"
    );
    const privateNoteSetting = defaultSettings?.find(
      (x: any) => x.settingsKey === "IsNotePrivate"
    );
    if (sendEmailSetting) {
      setEmailChecked(sendEmailSetting.settingsValue === "true");
    }
    if (privateNoteSetting) {
      setIsPrivateNote(privateNoteSetting.settingsValue === "true");
    }
    const effortSetting = defaultSettings?.find(
      (x: any) => x.settingsKey === "AddUpdateEffort"
    );

    if (effortSetting) {
      setUdateFormData((prev: any) => ({
        ...prev,
        effortMinute: effortSetting.settingsValue || "0"
      }));
    }
  }, [defaultSettings]);
  // console.log(
  //   "ticketInfo?.ticketLogs?.agentId",
  //   ticketInfo?.ticketLogs?.ticketTypeId
  // );
  useEffect(() => {
    if (ticketInfo?.ticketLogs?.outComeCategoryId)
      dispatch(getCategoryByID(ticketInfo?.ticketLogs?.outComeCategoryId));
  }, [ticketInfo?.ticketLogs?.outComeCategoryId]);
  const [statusList] = useState((ticketManagementProperties.ticketStatus||[]).filter((status:any)=>status.name!=="New"));
  const [updateFormData, setUdateFormData] = useState<any>({
    group: FindItem(
      ticketManagementProperties.groups,
      ticketInfo?.ticketLogs?.groupId
    ),
    agent: FindItem(
      ticketManagementProperties.AgentsList,
      ticketInfo?.ticketLogs?.agentId
    ),
    status: FindItem(
      ticketManagementProperties.ticketStatus,
      ticketInfo?.ticketLogs?.statusId
    ),
    contactOrganisationId: ticketInfo?.ticketLogs?.contactOrganisation
      ? {
        ...ticketInfo?.ticketLogs?.contactOrganisation,
        label: ticketInfo?.ticketLogs?.contactOrganisation?.name,
        value: ticketInfo?.ticketLogs?.contactOrganisation?.name,
      }
      : 0,
    note: "",
    thirdPartyRefNo: ticketInfo?.ticketLogs?.thirdPartyRefNo || null,
    effortDay: "0",
    effortHour: "00",
    effortMinute: "00",
    downTimeDay: "0",
    downTimeHour: "00",
    downTimeMinute: "00",
    template: null,
    attachment: [],
  });
  
  const [agentOptions, setAgentOptions] = useState<any>([]);
  const [groupOptions, setGroupOptions] = useState<any>([]);
  const [additionalFields,setAdditionalFields]= useState<any>({})
  const [additionalFieldserror,setAdditionalFieldserror]= useState<any>({})
  
 const noteRef: any = createRef();
  useEffect(() => {
    dispatch(getTemplates());
    dispatch(getAllGroup(getCallback));
    getDefaultSettings();
    if (noteRef?.current && ticketInfo?.ticketLogs?.isAISuggested) {
      noteRef.current.value = ticketInfo?.ticketLogs?.note || null;
    }
  }, []);
  const isNotesRequired = checkIsNoteFieldRequired(
    updateFormData?.status?.name
  );

  useEffect(() => {
    prefillTemnplateBasedOnStatus(updateFormData.status);
  }, [updateFormData.status, TemplatesList]);

  function filterAttachmentPaths(data: any) {
    // Use the map function to extract attachmentPath values
    if (data?.length > 0) {
      const attachmentPaths = data.map((item: any) => {
        return {
          AttachmentPath: item.fileName ? item.fileName : item.attachmentPath,
          isActive: item.fileName ? true : item?.isActive,
          ticketLogId: item.fileName ? 0 : item?.ticketLogId,
          id: item.fileName ? 0 : item?.id,
        };
      });
      // console.log("filterAttachmentPaths", attachmentPaths);
      return attachmentPaths;
    } else {
      return [];
    }
  }
  const validateWebForm = (enteredVal: any = {}) => {
    // console.log("enteredVal", enteredVal);
    let errObj: any = {
      hasError: false,
    };

    additionalFields[0]?.webformFieldList?.forEach((i: any) => {
      if(i?.isMandatory){ 
        if(i?.fieldType=="CheckBox"&& !enteredVal[i?.fieldLabel]){
          errObj[i?.fieldId]=`Please Enter ${i?.fieldLabel}`
          errObj.hasError = true;

        }
        else if(i?.fieldType =="DropDown" && ((enteredVal[i?.fieldLabel] == "pleaseSelect") || (enteredVal[i?.fieldLabel] == "please select") )){
          errObj[i?.fieldId]=`Please Select ${i?.fieldLabel}`
            errObj.hasError = true;
          }
      else if( enteredVal[i?.fieldLabel]?.length === 0 ||enteredVal[i?.fieldLabel]== "pleaseSelect") {
          errObj[i?.fieldId]=`Please Enter ${i?.fieldLabel}`
          errObj.hasError = true;
        }
      }
    });
    setAdditionalFieldserror(errObj)
    return errObj;
  };
  const onSubmit = (event: any) => {
    setLoading(true);
    const additionalFieldsContainerForm = event.currentTarget.querySelector('#ticket-additional-fields-form');
    const formDataAdditionalField = additionalFieldsContainerForm&&new FormData(additionalFieldsContainerForm);
    const AdditionalFielddata: any = {};
    // console.log("key---------mergeCheckBoxValues-----------",AdditionalFielddata);
  formDataAdditionalField?.forEach((value:any, key:any) => {
      if (key.startsWith("checkBox_")) {
        let keyarray = key.split("_");
        const groupKey = keyarray[1]; // e.g. part after "checkBox_"

        if (!AdditionalFielddata[groupKey]) {
          AdditionalFielddata[groupKey] = value.toString();
        } else {
          AdditionalFielddata[groupKey] += ',' + value.toString();
        }
      } else {
        AdditionalFielddata[key] = value.toString();
      }
    });

    const AdditionalFielderrors = (updateFormData?.status?.name === "Resolved" || updateFormData?.status?.name === "Closed") && validateWebForm(AdditionalFielddata);
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const data: iFormData = {};
    formData.forEach((value, key) => {
      data[key] = value.toString();
    });

    let allFields = {
      groupId: generateIdFromObjectForTicketCreation(updateFormData.group),
      agentId: generateIdFromObjectForTicketCreation(updateFormData.agent),
      statusId: generateIdFromObjectForTicketCreation(updateFormData.status),
      note: data.note || "",
      template: generateIdFromObjectForTicketCreation(updateFormData.template),
      contactOrganisationId: generateIdFromObjectForTicketCreation(updateFormData.contactOrganisationId),
      thirdPartyRefNo : data?.thirdPartyRefNo || updateFormData?.thirdPartyRefNo,
      outcomeCategoryId : outcomeCategoryId
    };

    const requiredFields:IValidationField[] = [
      {field:"groupId", type:"dropdown"},
      {field:"agentId", type:"dropdown"},
      {field:"statusId", type:"dropdown"},
    ];
    const validationDataForUpdate:any = {
      groupId: generateIdFromObjectForTicketCreation(updateFormData.group),
      agentId: generateIdFromObjectForTicketCreation(updateFormData.agent),
      statusId: generateIdFromObjectForTicketCreation(updateFormData.status),
    };
    /*Adding validation field on condition*/
    if (updateFormData?.status?.name === "ThirdParty") {
      requiredFields.push(
        // { field: "thirdPartyRefNo", type: "text" },
        { field: "contactOrganisationId", type: "dropdown" }
      );
      // validationDataForUpdate["thirdPartyRefNo"] = allFields["thirdPartyRefNo"];
      validationDataForUpdate["contactOrganisationId"] = allFields["contactOrganisationId"];
    }
    if (emailChecked) {
      requiredFields.push({ field: "template", type: "dropdown" });
      validationDataForUpdate["template"] = allFields["template"];
    }
    if (isNotesRequired) {
      requiredFields.push({ field: "note", type: "text" });
      validationDataForUpdate["note"] = allFields["note"];
    }
    // console.log("TRUE IF EXIST",hasOutcomeCategory);
    if (["Resolved", "Closed"].includes(updateFormData?.status?.name) && hasOutcomeCategory) {
      requiredFields.push({ field: "outcomeCategoryId", type: "dropdown" });
      // validationDataForUpdate["outcomeCategoryId"] = allFields["outcomeCategoryId"];
      validationDataForUpdate["outcomeCategoryId"] = outcomeCategoryId || "";
    }
    /*Adding validation field on condition ENDS*/

    let validationSchema = getValidationSchema(requiredFields);

    const validation = isValidate(validationDataForUpdate, validationSchema);
    if (validation.isValid && !AdditionalFielderrors?.hasError) {
      setError({ isValid: false, errors: {} });
      const oldLog = ticketInfo?.id ? respData?.respData?.ticketLogs : {};
      let payload: any = {
        id: ticketInfo?.id ? Number(ticketInfo?.id) : 0,
        sourceCode: ticketInfo.sourceCode,
        ticketLogs: {
          ...oldLog,
          ...ticketInfo.ticketLogs,
          ...validationDataForUpdate,
          IsNotePrivate: isNotePrivate,
          note: allFields["note"],
          group: updateFormData.group,
          ticketStatus: updateFormData.status,
          outComeCategoryId: outcomeCategoryId?.id || outcomeCategoryId || null,
          "ticketAdditionalField": (updateFormData?.status?.name === "Resolved" || updateFormData?.status?.name === "Closed") ? AdditionalFielddata : {},
          agent: {
            id: updateFormData?.agent?.id,
            firstName: updateFormData?.agent?.label,
            email: updateFormData?.agent?.email,
          },
          effort: convertToTimeSpan(
            data?.effortDay,
            data?.effortHour,
            data?.effortMinute
          ),
          downtime: convertToTimeSpan(
            data?.downTimeDay,
            data?.downTimeHour,
            data?.downTimeMinute
          ),
          ticketLogAttachmentsList: filterAttachmentPaths(
            ticketInfo.type !== "addOrEdit"
              ? updateFormData.attachment
              : ticketInfo?.ticketLogs?.ticketLogAttachmentsList
          ),
          circulationListTO: ticketInfo.ticketLogs?.circulationListTO,
          circulationListCC: ticketInfo?.ticketLogs?.circulationListCC,
          circulationListBCC: ticketInfo?.ticketLogs?.circulationListBCC,
          thirdPartyRefNo:
            data?.thirdPartyRefNo ||
            updateFormData?.thirdPartyRefNo ||
            null,
          contactOrganisationId:
            updateFormData?.contactOrganisationId?.id || 0,
        },
        ticketAssetList: ticketInfo.ticketAssetList,
        ticketRelationshipList: null,
        ticketTagList: ticketInfo.ticketTagList,
        ticketTaskList: [],
        totalEffort: ticketInfo.totalEffort,
      }

      // // return
      if (ticketInfo.id) {
        updateTicket(ticketInfo.id, payload).then((res: any) => {
          if (res.status == 200) {
            setLoading(false);
            const updatedTckt: any = res.data;
            // console.log("updatedTcktupdatedTckt", res.data);
            dispatch({
              type: "UPDATE_LIST_AFTER_QUICKUPDATE",
              payload: {
                ticketId: res.data.id,
                ticketInfo: res.data,
              },
            });
            res?.data?.ticketLogs?.ticketLogAttachmentsList.map(
              (item: any, index: any) => {
                ticketInfo.type !== "addOrEdit"
                  ? fileUploadServiceForBloeStorage(
                    item.attachmentPath,
                    updateFormData.attachment[index].formFile,
                    (isDone: any, res: any) => {
                      if (isDone) {
                        // console.log("inputFileHandler file uploaded", res);
                        // navigate("/contact");
                      } else {
                        // console.log("inputFileHandler file failed", res);
                      }
                    }
                  )
                  : fileUploadServiceForBloeStorage(
                    item.attachmentPath,
                    ticketInfo?.ticketLogs?.ticketLogAttachmentsList[index]
                      .formFile,
                    (isDone: any, res: any) => {
                      if (isDone) {
                        // console.log("inputFileHandler file uploaded", res);
                        // navigate("/contact");
                      } else {
                        // console.log("inputFileHandler file failed", res);
                      }
                    }
                  );
              }
            );

            //Old values
            const oldStatusName = ticketInfo?.ticketLogs?.ticketStatus?.name;
            const oldAgentId = ticketInfo?.ticketLogs?.agent?.id;
            const oldGroupId = ticketInfo?.ticketLogs?.group?.id;

            //New values
            const newStatusName = updateFormData?.status?.name;
            const newAgentId = updateFormData?.agent?.id;
            const newGroupId = updateFormData?.group?.id;

            //Check status changed
            const isStatusUpdated =
              oldStatusName &&
              newStatusName &&
              oldStatusName.toLowerCase() !== newStatusName.toLowerCase();

            //Check agent changed
            const isAgentChanged =
              oldAgentId &&
              newAgentId &&
              Number(oldAgentId) !== Number(newAgentId);

            //Check group changed
            const isGroupChanged =
              oldGroupId &&
              newGroupId &&
              Number(oldGroupId) !== Number(newGroupId);

            //ONLY show status message when ONLY status changed
            const showStatusMessage =
              isStatusUpdated && !isAgentChanged && !isGroupChanged;

            const message = showStatusMessage
              ? `${LanguageData.SUCCESS} (${ticketInfo.id}) ${LanguageData.TICKET_UPDATED} to ${newStatusName}`
              : `${LanguageData.SUCCESS} (${ticketInfo.id}) ${LanguageData.TICKET_UPDATED}`;

          
            if (emailChecked) {
              dispatch(triggerAppAlert(message, "success"));
              onCloseHandler();
              dispatch({
                type: "SEND_EMAIL_VIEW",
                payload: {
                  ...res.data,
                  template: updateFormData.template,
                  addUpdate: true
                },
              });
            } else {
              onCloseHandler();
              if (ticketInfo?.type == "update") {
                // navigate(-1);
                dispatch(triggerAppAlert(message, "success"));
              } else {
                if (callback) {
                  callback(res?.data);
                  dispatch(triggerAppAlert(message, "success"));
                } else {
                  dispatch(getTicketAndUpdateLists(res?.data.id, "edit",()=>{
                    navigate("/TicketManagementSys");
                    dispatch(triggerAppAlert(message, "success"));
                  }));
                }
                //dispatch(newFilterAllTickets(AllInfo?.statusTypes));
              }
            }
          } else {
            setLoading(false);
            dispatch({
              type: ActionType.SNACKBAR,
              payload: {
                message: `Ticket Update Failed`,
                severity: "error",
                open: true,
              },
            });
          }
        });
      } else {
        ticketCreation(payload).then((res: any) => {
          if (res.status == 201) {
            setLoading(false);
            
            // {res.}
            // console.log(
            //   "response ticket creation",
            //   res?.data?.ticketLogs?.ticketLogAttachmentsList,
            //   ticketInfo?.ticketLogs?.ticketLogAttachmentsList
            // );
            res?.data?.ticketLogs?.ticketLogAttachmentsList.map(
              (item: any, index: any) => {
                fileUploadServiceForBloeStorage(
                  item.attachmentPath,
                  ticketInfo?.ticketLogs?.ticketLogAttachmentsList[index]
                    .formFile,
                  (isDone: any, res: any) => {
                    if (isDone) {
                      // console.log("inputFileHandler file uploaded", res);
                      // navigate("/contact");
                    } else {
                      // console.log("inputFileHandler file failed", res);
                    }
                  }
                );
              }
            );

            

            
              
            if (emailChecked) {
              onCloseHandler();
              dispatch(getTicketAndUpdateLists(res?.data.id, "create",()=>{
                // navigate("/TicketManagementSys");
                dispatch(triggerAppAlert(`${LanguageData.TICKET_ADDED_SUCCESSFULLY}${res?.data?.id}`, "success"));
              }));
              dispatch({
                type: "SEND_EMAIL_VIEW",
                payload: {
                  ...res.data,
                  template: updateFormData.template,
                  addUpdate: true
                },
              });
            } else {
              onCloseHandler();
              dispatch(getTicketAndUpdateLists(res?.data.id, "create",()=>{
                navigate("/TicketManagementSys");
                dispatch(triggerAppAlert(`${LanguageData.TICKET_ADDED_SUCCESSFULLY}${res?.data?.id}`, "success"));
              }));
            }
          } else {
            setLoading(false);
            dispatch({
              type: ActionType.SNACKBAR,
              payload: {
                message: `Ticket creation Failed`,
                severity: "error",
                open: true,
              },
            });
          }
        });
      }
    } else {
      // Form is invalid, update the errors state
      setError(validation);
      setLoading(false);
    }
  };

  const handleSelectChange = (e: unknown, type: string) => {
    setUdateFormData((prevUserFormData: any) => {
      return {
        ...prevUserFormData,
        [type]: e,
      };
    });
  };

  const onCloseHandler = useCallback(() => {
    dispatch({
      type: "ADD_UPDATE_POPUP_INFO",
      payload: null,
    });
  }, []);

  useEffect(() => {
    // console.log("currAgentcurrAgentcurrAgent", updateFormData.agent, currAgent);

    if (currAgent) {
      if (!updateFormData.agent) {
        let currAgentModifiedObjectForSelect: any = {
          label: `${currAgent.firstName} ${currAgent.lastName} (${currAgent.userName})`,
          name: currAgent.firstName,
          value: currAgent.id,
          id: currAgent.id,
          color: "red",
          email: currAgent?.email,
        };
        let isCurrAgentPresentInAgentList: any = FindItem(
          ticketManagementProperties.AgentsList,
          currAgentModifiedObjectForSelect.id
        );
        // console.log(
        //   "isCurrAgentPresentInAgentList",
        //   isCurrAgentPresentInAgentList,
        //   currAgentModifiedObjectForSelect,
        //   ticketManagementProperties.AgentsList
        // );

        if (isCurrAgentPresentInAgentList) {
          handleSelectChange(currAgentModifiedObjectForSelect, "agent");
          if (!ticketInfo?.ticketLogs?.isAISuggested && !ticketInfo?.ticketLogs?.forceUpdateStatus) {
            prefillStatusBasedOnAgentChange(currAgentModifiedObjectForSelect);
          }
        }
      } else {
        // prefillStatusBasedOnAgentChange(updateFormData.agent);
      }

      if (!updateFormData.group) {
        let isDefault = null;
        (currAgent?.userGroupList || []).filter((ele: any) => {
          if (ele.isDefault == true) {
            isDefault = ele.groupId;
          }
        });
        let isDefaultPresentForCurrAgent: any = FindItem(
          ticketManagementProperties.groups,
          isDefault
        );
        // console.log("currAgentcurrAgentcurrAgent", currAgent);

        if (isDefaultPresentForCurrAgent) {
          handleSelectChange(isDefaultPresentForCurrAgent, "group");
          prefillAgentOptionsBasedGroup(isDefaultPresentForCurrAgent);
        }
      } else {
        prefillAgentOptionsBasedGroup(updateFormData.group);
      }
    }
  }, [currAgent]);

  useEffect(() => {
    if (statusIdFromUrl) {
      let statusTemp = ticketManagementProperties.ticketStatus.find(
        (x: any) => x.id == statusIdFromUrl
      );
      // console.log("priorityIdFromUrlpriorityIdFromUrl", statusTemp);

      handleSelectChange(statusTemp, "status");
      //------------------------------------------------------
      let currAgentModifiedObjectForSelect: any = {
        label: `${currAgent.firstName} ${currAgent.lastName} (${currAgent.userName})`,
        name: currAgent.firstName,
        value: currAgent.id,
        id: currAgent.id,
        color: "red",
        email: currAgent?.email,
      };
      let isCurrAgentPresentInAgentList: any = FindItem(
        ticketManagementProperties.AgentsList,
        currAgentModifiedObjectForSelect.id
      );
      if (isCurrAgentPresentInAgentList) {
        handleSelectChange(currAgentModifiedObjectForSelect, "agent");
        // prefillStatusBasedOnAgentChange(currAgentModifiedObjectForSelect);
      }
      let isDefault = null;
      (currAgent.userGroupList || []).filter((ele: any) => {
        if (ele.isDefault == true) {
          isDefault = ele.groupId;
        }
      });
      let isDefaultPresentForCurrAgent: any = FindItem(
        ticketManagementProperties.groups,
        isDefault
      );
      // console.log("currAgentcurrAgentcurrAgent", currAgent);

      if (isDefaultPresentForCurrAgent) {
        handleSelectChange(isDefaultPresentForCurrAgent, "group");
        prefillAgentOptionsBasedGroup(isDefaultPresentForCurrAgent);
      }
      //-----------------------------------------------------------------------
    }
  }, [statusIdFromUrl]);

  useEffect(() => {
    if (priorityIdFromUrl) {
      // console.log("hshshs", priorityIdFromUrl);
      let statusTemp = ticketManagementProperties.ticketStatus.find(
        (x: any) => x.name == "InProgress"
      );
      handleSelectChange(statusTemp, "status");
      let currAgentModifiedObjectForSelect: any = {
        label: `${currAgent.firstName} ${currAgent.lastName} (${currAgent.userName})`,
        name: currAgent.firstName,
        value: currAgent.id,
        id: currAgent.id,
        color: "red",
        email: currAgent?.email,
      };
      let isCurrAgentPresentInAgentList: any = FindItem(
        ticketManagementProperties.AgentsList,
        currAgentModifiedObjectForSelect.id
      );
      if (isCurrAgentPresentInAgentList) {
        handleSelectChange(currAgentModifiedObjectForSelect, "agent");
        prefillStatusBasedOnAgentChange(currAgentModifiedObjectForSelect);
      }
      let isDefault = null;
      (currAgent.userGroupList || []).filter((ele: any) => {
        if (ele.isDefault == true) {
          isDefault = ele.groupId;
        }
      });
      let isDefaultPresentForCurrAgent: any = FindItem(
        ticketManagementProperties.groups,
        isDefault
      );
      // console.log("currAgentcurrAgentcurrAgent", currAgent);

      if (isDefaultPresentForCurrAgent) {
        handleSelectChange(isDefaultPresentForCurrAgent, "group");
        prefillAgentOptionsBasedGroup(isDefaultPresentForCurrAgent);
      }
    }
  }, [priorityIdFromUrl]);

  const prefillAgentOptionsBasedGroup = (group: any) => {
    // console.log("prefillAgentOptionsBasedGroup", group, updateFormData.agent);
    if (group) {
      let temp: any = [];
      group.userGroupList?.filter((groupEle: any) => {
        if (groupEle?.isActive && groupEle?.agent?.isActive) {
          let a: any = {
            label: `${groupEle?.agent?.firstName} ${groupEle?.agent?.lastName}`,
            name: groupEle?.firstName,
            value: groupEle?.userId,
            id: groupEle?.userId,
            color: "red",
          };
          temp.push(a);
        }
      });
      setAgentOptions(temp);
    } else {
      setAgentOptions([]);
      setGroupOptions(ticketManagementProperties.groups);
    }
  };

  const prefillTemnplateBasedOnStatus = (status: any) => {
    const currentStatus = status?.name;
    const statusActionMap: Record<string, string> = {
      NewtoMe: "Assign",
      Resolved: "Resolve",
      Closed: "Close"
    };

    let action = statusActionMap[currentStatus];

    // If action is undefined, do nothing
    if (!action) {
      action = "AddUpdate";
    };

    handleSelectChange(null, "template");

    const filteredTemplates = TemplatesList.filter((ele: any) => ele.actions === action);

    setTemplate(filteredTemplates);

    if (filteredTemplates.length === 1) {
      handleSelectChange(filteredTemplates[0], "template");
    } else {
      handleSelectChange(null, "template");
    }
  };

  const prefillStatusBasedOnAgentChange = (agent: any) => {
    // console.log("prefillStatusBasedOnAgentChange", agent.id, currAgent.id);
    if (agent.id == currAgent.id) {
      let statusTemp = ticketManagementProperties.ticketStatus.find(
        (x: any) => x.name === "InProgress"
      );
      handleSelectChange(statusTemp, "status");
      prefillTemnplateBasedOnStatus(statusTemp);
    } else {
      let statusTemp = ticketManagementProperties.ticketStatus.find(
        (x: any) => x.name === "NewtoMe"
      );
      handleSelectChange(statusTemp, "status");
      prefillTemnplateBasedOnStatus(statusTemp);
    }
  };

  function truncateString(str: string) {
    if (str.length > 5) {
      return str.substring(0, 8) + "...";
    }
    return str;
  }

  const imgCallBack = async (params: any, file: any) => {
    let recs: any = updateFormData.attachment;
    recs.push({
      file: params,
      fileName: file.name,
      Type: file.type,
      formFile: file,
    });
    handleSelectChange([...recs], "attachment");
  };
  const onRemoveAttchment = (index: number) => {
    let allRecs = updateFormData?.attachment;
    allRecs.splice(index, 1);
    handleSelectChange([...allRecs], "attachment");
  };
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const getCallback = (resStatus: string, res: any) => {
    if (resStatus === "0") {
      res = res.map((i: any) => {
        return {
          ...i,
          agentsList: getUsrList(i?.userGroupList),
        };
      });
      setGroupOptions(res);
    }
  };
  const generateDownTimeBasedOnStatus = (status: any) => {
    // console.log("generateDownTimeBasedOnStatus", status,ticketInfo);
    if (
      (status?.name === "Closed" || status?.name === "Resolved") &&
      (ticketInfo?.ticketLogs?.ticketLogAssetList?.length > 0 ||
        ticketInfo?.ticketAssetList?.length > 0 ||
        ticketInfo?.assets?.length > 0)
    ) {
      return (
        <Box sx={{ ml: 1, pt: 1 }}>
          <CustomFormLabel labelName={"Downtime"} isMandotary={false} />
          <Box style={{ display: "flex", width: '100%', flexDirection: "row", gap: 10 }}>
            <Box sx={{ width: '100%' }}>
              <CustomInput
                type="number"
                isDisabled={false}
                readOnly={false}
                onClick={null}
                iconPosition={"start"}
                icon={false}
                isError={false}
                label={"Enter the downTime"}
                name="downTimeHour"
                helperText={""}
                placeholder={"Hours"}
              />{" "}
            </Box>
            <Box sx={{ width: '100%' }}>
              <CustomInput
                type="number"
                isDisabled={false}
                readOnly={false}
                onClick={null}
                iconPosition={"start"}
                icon={false}
                isError={false}
                label={"Enter the downTime"}
                name="downTimeMinute"
                helperText={""}
                placeholder={"Mins"}
              />{" "}
            </Box>
          </Box>
        </Box>
      );
    }
  };
  const promiseOptionsForOrg = debounce((inputValue: any, callback: any) => {
    if (inputValue.length > 2) {
      dispatch(getOrganisationsForDropdown(inputValue, callback, true));
    } else {
      callback([]); // Pass options to the callback
    }
  }, 300);
  const unsetNoteFieldErrorMsg = (val?: any) => {
    const isNoteRequired = checkIsNoteFieldRequired(
      `${val || updateFormData?.status?.name}`
    );
    if (!isNoteRequired || noteRef?.current?.value.trim() !== "") {
      setError({
        ...error,
        errors: {
          ...error.errors,
          note: [],
        },
      });
    }
  }
  const unsetNotesAndOutcomeErrorMsg = (val?:any) =>{
    const isNoteRequired = checkIsNoteFieldRequired(`${val || updateFormData?.status?.name}`);
    const tempObj = {...error};
    if(!isNoteRequired || noteRef?.current?.value.trim() !== ""){
      if(tempObj?.errors?.note) tempObj.errors.note = [];
    }
    if(tempObj?.errors?.outcomeCategoryId) tempObj.errors.outcomeCategoryId = [];
    setError(tempObj);
  }
  const unsetErrOnField = (field:string) =>{
    setError({
      ...error,
      errors: {
        ...error.errors,
          [field] : []
      }
    })
  }
  const unsetErrFromStatusField = (e:any) =>{
    const tempObj:any = {
      ...error,
      errors: {
        ...error.errors,
          "statusId" : []
      }
    }
    if(checkIsNoteFieldRequired(e?.name)){
      tempObj.errors.note = [];
    }
    setError(tempObj);
  };
  //  console.log("updateFormDataupdateFormData",updateFormData);
  const articleModalData = useSelector((state: IState) => state?.TicketViewReducer?.articleModal);  
  return (
    <>
      <form onSubmit={onSubmit}>
        <Box className="modal-body">
          <Box className="p-1">
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                width: '100%',
              }}
            >
              <Box
                sx={{
                  flex: '1 1 calc(50% - 16px)',
               }}
              >
                <CustomFormLabel labelName={"Group"} isMandotary={true} />
                <CustomSelect
                  isOpen={false}
                  placeholder="Select Group"
                  width={"100%"}
                  name="group"
                  isColor={false}
                  isDisabled={false}
                  isError={(!updateFormData.group && generateErrorList(error.isValid, error.errors, "groupId")) ? true : false}
                  defaultValue={updateFormData.group}
                  options={groupOptions}
                  handleChange={(e: any) => {
                    handleSelectChange(e, "group");
                    handleSelectChange(null, "agent");
                    prefillAgentOptionsBasedGroup(e);
                  }}
                  isMulti={false}
                  helperText={""}
                />
                {!updateFormData.group && generateErrorList(error.isValid, error.errors, "groupId")}
              </Box>
              <Box
                sx={{
                  flex: '1 1 calc(50% - 16px)',
                }}
              >
                <CustomFormLabel labelName={"Owner"} isMandotary={true} />
                <CustomSelect
                  isOpen={false}
                  placeholder="Select Owner"
                  width={"100%"}
                  name="agent"
                  isColor={false}
                  isDisabled={false}
                  isError={(!updateFormData.agent && generateErrorList(error.isValid, error.errors, "agentId")) ? true : false}
                  defaultValue={updateFormData.agent}
                  options={agentOptions}
                  handleChange={(e: any) => {
                    handleSelectChange(e, "agent");
                    prefillStatusBasedOnAgentChange(e);
                    unsetErrFromStatusField(e);
                  }}
                  isMulti={false}
                  helperText={""}
                />
                {!updateFormData.agent && generateErrorList(error.isValid, error.errors, "agentId")}
              </Box>
              <Box
                sx={{
                  flex: '1 1 calc(50% - 16px)',
                }}
              >
                <CustomFormLabel labelName={"Status"} isMandotary={true} />
                <CustomSelect
                  isOpen={false}
                  placeholder="Select Status"
                  width={"100%"}
                  name="status"
                  isColor={false}
                  handleChange={(e: any) => {
                    handleSelectChange(e, "status");
                    unsetNotesAndOutcomeErrorMsg(e?.name)
                    prefillTemnplateBasedOnStatus(e);
                    if (!["Resolved", "Closed"].includes(e?.name)) {
                      setOutcomeCategoryId(null);
                    }
                  }}
                  isDisabled={false}
                  isError={(!updateFormData.ticketStatus && generateErrorList(error.isValid, error.errors, "statusId")) ? true : false}
                  defaultValue={updateFormData.status}
                  options={statusList}
                  isMulti={false}
                  helperText={""}
                />
                {!updateFormData.ticketStatus && generateErrorList(error.isValid, error.errors, "statusId")}

              </Box>

                {((updateFormData?.status?.name === "Resolved" ||
                updateFormData?.status?.name === "Closed")) && (
                  <Box
                    sx={{
                      flex: '1 1 calc(50% - 16px)',
                     
                    }}
                  >
                    {/* <CloseCategoryOption ticketTypeId={ticketInfo?.ticketLogs?.ticketTypeId} /> */}
                    <CloseCategoryOption
                      gridCol={6}
                      isGridTag={false}
                      ticketTypeId={ticketInfo?.ticketLogs?.ticketTypeId ||respData?.respData?.ticketLogs?.ticketType?.id }
                      onSelectOutcome={(outcomeCategoryId) => {
                        setOutcomeCategoryId(outcomeCategoryId); // Save the selected outcome category ID
                        unsetErrOnField("outcomeCategoryId");
                      }}
                      outComeCategoryId={
                        ticketInfo?.ticketLogs?.outComeCategoryId ||  respData?.respData?.ticketLogs?.outComeCategoryId 
                      }
                      setHasOutcomeCategory={setHasOutcomeCategory}
                      isError={(!outcomeCategoryId && error?.errors?.outcomeCategoryId?.length > 0) ? true : false}
                    />
                    {/* {!outcomeCategoryId && <>
                    {generateErrorList(error.isValid, error.errors, "outcomeCategoryId")}
                  </>} */}
                  </Box>
                )}
      <Box
                sx={{
                  flex: '1 1 calc(50% - 16px)',
               }}
              >

                <TextBoxLatest
                  title="Note"
                  isMandotary={isNotesRequired}
                  placeholder="Enter the Note"
                  ref={noteRef}
                  errorMsg={generateErrorList(error.isValid, error.errors, "note")}
                  isError={generateErrorList(error.isValid, error.errors, "note") ? true : false}
                  onchangeHandler={unsetNoteFieldErrorMsg}
                  name="note"
                  multiline={true}
                />
              </Box>
             {(updateFormData?.status?.name === "Resolved" || updateFormData?.status?.name === "Closed") && (
                <Box sx={{ width: '100%', mt: 2 }}>
                 
                  { (
                    <Box
                      sx={{
                     
                      }}
                    >
                      <form id="ticket-additional-fields-form" style={{ width: '100%' }}>
                        <TicketAdditionalField
                          ticketTypeId={respData?.respData?.ticketLogs?.ticketType?.id || ticketInfo?.ticketLogs?.ticketTypeId}
                          setAdditionalFields={setAdditionalFields}
                          additionalFieldserror={additionalFieldserror}
                          savedsetAdditionalFields={respData?.respData?.ticketLogs?.ticketAdditionalField || ticketInfo?.ticketLogs?.ticketAdditionalField}
                        />
                      </form>
                    </Box>
                  )}
                </Box>
              )}
             
              {updateFormData?.status?.name == "ThirdParty" && (
                <>
                  <Box
                    sx={{
                      flex: '1 1 calc(50% - 16px)',
                    }}
                  >
                    <br />
                    <CustomFormLabel
                      labelName={"Please Enter Third Party Organisation"}
                      isMandotary={true}
                    />
                    <AsyncDropDown
                      promiseOptions={promiseOptionsForOrg}
                      name="contactOrganisationId"
                      placeHolder="Search and select a Third Party"
                      handleChange={(e: any) => {
                        handleSelectChange(e, "contactOrganisationId");
                      }}
                      isError={( !updateFormData.contactOrganisationId && generateErrorList(error.isValid, error.errors, "contactOrganisationId")) ? true : false}
                      defaultValue={updateFormData.contactOrganisationId}
                    />
                    <p style={{fontSize:"12px",margin:0, color:"#c8c8c8"}}>* You need at least 3 characters to search</p>
                    {!updateFormData.contactOrganisationId && generateErrorList(
                      error.isValid,
                      error.errors,
                      "contactOrganisationId"
                    )}
                  </Box>
                  <Box
                    sx={{
                      flex: '1 1 calc(50% - 16px)',
                   }}
                  >
                    <br />
                    <CustomFormLabel
                      labelName={"Please Enter Third Party Ref Number"}
                      isMandotary={false}
                    />
                    <CustomInput
                      isDisabled={false}
                      readOnly={false}
                      onClick={null}
                      onChange={(e:any)=>{
                        handleSelectChange(e.target.value, "thirdPartyRefNo");
                        unsetErrOnField("thirdPartyRefNo")
                      }}
                      iconPosition={"start"}
                      icon={false}
                      isError={false}
                      // isError={
                      // (!updateFormData.thirdPartyRefNo &&
                      //   generateErrorList(error.isValid, error.errors, "thirdPartyRefNo"))
                      //   ? true
                      //   : false
                      // }
                      label={"Enter the Third Party Ref Number"}
                      name="thirdPartyRefNo"
                      defaultValue={updateFormData?.thirdPartyRefNo || ""}
                      helperText={""}
                      placeholder={"Third Party Ref Number"}
                    />
                    {/* {generateErrorList(
                      error.isValid,
                      error.errors,
                      "thirdPartyRefNo"
                    )} */}
                  </Box>
                </>
              )}
            
              {/* <Box
                sx={{
                  flex: '1 1 calc(50% - 16px)',
               }}
              >

                <TextBoxLatest
                  title="Note"
                  isMandotary={isNotesRequired}
                  placeholder="Enter the Note"
                  ref={noteRef}
                  errorMsg={generateErrorList(error.isValid, error.errors, "note")}
                  isError={generateErrorList(error.isValid, error.errors, "note") ? true : false}
                  onchangeHandler={unsetNoteFieldErrorMsg}
                  name="note"
                  multiline={true}
                />
              </Box> */}

              {/* {(updateFormData?.status?.name === "Resolved" || updateFormData?.status?.name === "Closed") &&
                <form id="ticket-additional-fields-form"style={{width:'100%'}} >
                  <TicketAdditionalField
                    ticketTypeId={respData?.respData?.ticketLogs?.ticketType?.id || ticketInfo?.ticketLogs?.ticketTypeId}
                    setAdditionalFields={setAdditionalFields}
                    additionalFieldserror={additionalFieldserror}
                    savedsetAdditionalFields={respData?.respData?.ticketLogs?.ticketAdditionalField || ticketInfo?.ticketLogs?.ticketAdditionalField}
                  />
                  
                </form>

              } */}

              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1,
                  width: '100%',
                }}
              >
                <Box 
              sx={{ 
                flex: '1 1 calc(50% - 16px)',
               }}
            > <GenrateTemplateField
                key={emailChecked ? "email-checked" : "email-unchecked"}
                setEmailChecked={setEmailChecked}
                emailChecked={emailChecked}
                isEmailShow={isEmailShow}
                handleSelectChange={handleSelectChange}
                value={updateFormData.template}
                template={template}
                setTemplate={setTemplate}
                error={error}
              /></Box>
             
              <Box 
              sx={{ 
                flex: '1 1 calc(50% - 16px)',
              }}
            > <GenratePrivateRadioBtn
                key={isNotePrivate ? "private-yes" : "private-no"}
                setEmailChecked={setIsPrivateNote}
                emailChecked={isNotePrivate}
              />
              </Box>
             </Box>

    <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1,
                  width: '100%',
                }}
              >
                <Box
                  sx={{
                    flex: '1 1 calc(50% - 16px)',
                   
                  }}
                >
                  <Box sx={{ ml: 1, pt: 1}}>
                    <CustomFormLabel labelName={"Effort"} isMandotary={false} /> </Box>
                  <Box sx={{ display: "flex", width: '100%', flexDirection: "row", gap: 2, }}>
                    <Box sx={{ width: '100%' }}>
                      <CustomInput
                        type="number"
                        isDisabled={false}
                        readOnly={false}
                        onClick={null}
                        iconPosition={"start"}
                        icon={false}
                        isError={false}
                        label={"Enter the effort"}
                        name="effortHour"
                        helperText={""}
                        placeholder={"Hours"}
                      />
                    </Box>
                    <Box sx={{ width: '100%' }}>
                      <CustomInput
                        type="number"
                        isDisabled={false}
                        readOnly={false}
                        onClick={null}
                        iconPosition={"start"}
                        icon={false}
                        isError={false}
                        label={"Enter the effort"}
                        name="effortMinute"
                        helperText={""}
                        placeholder={"Minutes"}
                        value={updateFormData?.effortMinute}
                        onChange={(e: any) => {
                          let value = e.target.value;
                          if (value > 59) value = 59;
                          if (value < 0) value = 0;
                          handleSelectChange(value, "effortMinute");
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box sx={{
                    flex: '1 1 calc(50% - 16px)',
                  }}
                >
                  {generateDownTimeBasedOnStatus(updateFormData.status)}
                </Box>
              </Box>


            </Box>
            {ticketInfo.type !== "addOrEdit" && (
              <Box sx={{
                  flex: '1 1 calc(50% - 16px)',
                }}
              >
                <input
                  id="AssetFileUpload"
                  accept=".jpeg, .img, .png, .pdf, .bmp, .doc, .msg, .docx, .jpg, .csv, .xlxs, .xls, .eml"
                  type="file"
                  multiple={true}
                  onChange={(e: any) => {
                    // setProgress(true);
                    const files = Array.from(e.target.files);
                    files.forEach((file: any) => {
                      getBase64(file, imgCallBack);
                    });
                    e.target.value = "";
                  }}
                  //value={FileUploadVal}
                  className="d-none"
                />

                <label
                  htmlFor="AssetFileUpload"
                  className="Add-Attachment"
                  style={{
                    fontSize: "16px",
                    cursor: "pointer",
                    float: "left",
                    color: "#0A93FC",
                    marginTop: "30px",
                    marginBottom: "10px",
                  }}
                  onClick={(e: any) => {}}
                >
                  + Add attachments
                </label>
                <>
                  {updateFormData.attachment?.length > 0 ? (
                    <div
                      style={{
                        width: "100%",
                        height: "auto",
                        padding: "25px",
                        display: "flex",
                      }}
                    >
                      <Slider {...settings}>
                        {updateFormData.attachment?.map(
                          (item: any, key: number) => {
                            // console.log("AssetImagesAssetImages", item);

                            return (
                              <Box
                                sx={{ position: "relative", margin: "auto" }}
                              >
                                <Box
                                  className="slider-img"
                                  sx={{
                                    position: "relative",
                                    width: "100px",
                                    margin: "auto",
                                  }}
                                  onClick={() => {
                                    // deleteAttachment(key);
                                  }}
                                >
                                  <IconButton
                                    aria-label="delete"
                                    style={{
                                      position: "absolute",
                                      top: -10,
                                      right: -20,
                                      backgroundColor: "white",
                                    }}
                                    onClick={() => {
                                      onRemoveAttchment(key);
                                    }}
                                  >
                                    {" "}
                                    <RemoveCircleIcon sx={{ color: "red" }} />
                                  </IconButton>
                                  {item.Type == "application/pdf" && (
                                    <PictureAsPdfIcon
                                      sx={{
                                        width: "100px",
                                        height: "100px",
                                        color: "gray",
                                        margin: "auto",
                                        borderRadius: "10px",
                                        border: "1px solid gray",
                                      }}
                                      onClick={() => {
                                        var pdfResult = item.file;
                                        let pdfWindow: any = window.open("");
                                        pdfWindow.document.write(
                                          "<iframe width='100%' height='100%' src='" +
                                          encodeURI(pdfResult) +
                                          "'></iframe>"
                                        );
                                      }}
                                    />
                                  )}

                                  {item.Type == "image/png" && (
                                    <img
                                      src={`${item.file}`}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        margin: "auto",
                                        borderRadius: "10px",
                                        border: "1px solid gray",
                                      }}
                                      alt="image"
                                      onClick={() => {
                                        let image = new Image();
                                        image.src = item.file;
                                        var newTab: any = window.open();
                                        newTab.document.body.innerHTML =
                                          image.outerHTML;
                                      }}
                                    />
                                  )}

                                  {item.Type == "image/jpeg" && (
                                    <img
                                      src={`${item.file}`}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        margin: "auto",
                                        borderRadius: "10px",
                                        border: "1px solid gray",
                                      }}
                                      alt="image"
                                      onClick={() => {
                                        let image = new Image();
                                        image.src = item.file;
                                        var newTab: any = window.open();
                                        newTab.document.body.innerHTML =
                                          image.outerHTML;
                                      }}
                                    />
                                  )}
                                  {item.Type == "image/jpg" && (
                                    <img
                                      src={`${item.file}`}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        margin: "auto",
                                        borderRadius: "10px",
                                        border: "1px solid gray",
                                      }}
                                      alt="image"
                                      onClick={() => {
                                        let image = new Image();
                                        image.src = item.file;
                                        var newTab: any = window.open();
                                        newTab.document.body.innerHTML =
                                          image.outerHTML;
                                      }}
                                    />
                                  )}

                                  {item.Type === "application/msword" && (
                                    <img
                                      onClick={() =>
                                        onClickThumbNail(fileAttachment)
                                      }
                                      src={`${WordImg}`}
                                      width={100}
                                      height={100}
                                    />
                                  )}
                                  {item.Type ===
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" && (
                                      <img
                                        onClick={() =>
                                          onClickThumbNail(fileAttachment)
                                        }
                                        src={`${WordImg}`}
                                        width={100}
                                        height={100}
                                      />
                                    )}
                                  {item.Type === "text/csv" && (
                                    <img
                                      onClick={() =>
                                        onClickThumbNail(fileAttachment)
                                      }
                                      src={`${CsvImg}`}
                                      width={100}
                                      height={100}
                                    />
                                  )}
                                  {["eml", "message/rfc822"].includes(
                                    item.Type
                                  ) && (
                                      <img
                                        onClick={() =>
                                          onClickThumbNail(fileAttachment)
                                        }
                                        src={`${emlFormat}`}
                                        width={100}
                                        height={100}
                                      />
                                    )}
                                  {item.Type === "xlsx" && (
                                    <img
                                      onClick={() =>
                                        onClickThumbNail(fileAttachment)
                                      }
                                      src={`${XlxsImg}`}
                                      width={100}
                                      height={100}
                                    />
                                  )}
                                  {item.Type === "application/vnd.ms-excel" && (
                                    <img
                                      onClick={() =>
                                        onClickThumbNail(fileAttachment)
                                      }
                                      src={`${XlxsImg}`}
                                      width={100}
                                      height={100}
                                    />
                                  )}

                                  {item.Type == "image/bmp" && (
                                    <img
                                      src={`${item.file}`}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        margin: "auto",
                                        borderRadius: "10px",
                                        border: "1px solid gray",
                                      }}
                                      alt="image"
                                      onClick={() => {
                                        let image = new Image();
                                        image.src = item.file;
                                        var newTab: any = window.open();
                                        newTab.document.body.innerHTML =
                                          image.outerHTML;
                                      }}
                                    />
                                  )}
                                  <p>{addEllipsis(item?.fileName, 10)}</p>
                                  {/* <HighlightOffOutlinedIcon /> */}
                                </Box>
                              </Box>
                            );
                          }
                        )}
                      </Slider>
                    </div>
                  ) : (
                    <>
                      {/* <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                        marginBottom: "30px",
                      }}
                    >
                      <AttachmentIcon
                        sx={{ width: "50px", height: "50px", color: "#2F80ED" }}
                      />
                      <div>Selected Attachments will appear here</div>
                    </div> */}
                    </>
                  )}
                </>
              </Box>
            )}
          </Box>
        </Box>
        <Box className="modal-footer">
          <Box className="text-right p-1">
          {!articleModalData && (<>
            <BasicButton
              onClick={onCloseHandler}
              type={"cancel"}
              isLoading={false}
              isDisabled={false}
              color="primary"
              size="large"
              label={"Cancel"}
              variant={"outlined"}
              endIcon={<CloseIcon sx={{ width: "20px" }} />}
            />

            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <BasicButton
              type="submit"
              label={"Save"}
              isLoading={loading}
              disabled={loading}
              color="primary"
              size="large"
              variant={"contained"}
              endIcon={<SaveIcon sx={{ width: "20px" }} />}
            />
            </>)}
          </Box>
        </Box>
      </form>
    </>
  );
};
export const useTicketAddUpdatePopupStyles = makeStyles(() =>
  createStyles({
    row: {
      display: "flex",
    },
    txtWithLink: {
      fontSize: ".7em",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      "& span": {
        wordBreak: "break-all",
      },
      "& a": {
        fontSize: ".7em",
        textDecoration: "none",
        display: "inline-block",
        lineHeight: 1,
        "& svg": {
          fontSize: "12px",
        },
      },
    },
    popupHolder: {
      position: "fixed",
      top: 0,
      left: 0,
      background: "#0005",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      zIndex: 1200,
      "& .modal-dialog": {
        display: "flex",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      },
      "& .modal-header": {
        display: "flex",
        alignItems: "center",
        padding: "20px",
        justifyContent: "space-between",
        borderBottom: "1px solid #ddd",
        paddingBottom: "10px",
      },
      "& .modal-body": {
        maxHeight: "calc(100vh - 200px)",
        overflowY: "scroll",
        padding: "0px",
      },
      "& .modal-body > div": {
        margin: "0 !important",
        maxWidth: "calc(100% - 15px)",
      },
      "& .modal-content": {
        background: "#fff",
        width: "100%",
        maxWidth: "1000px",
        borderRadius: "5px",
        //padding: "20px",
        "& img.Contactprofile": {
          width: "calc(100% - 10px)",
        },
        "& img": {
          objectFit: "cover",
        },
      },
    },
  })
);
export default TicketAddUpdatePopup;
